import { Maybe } from "graphql/jsutils/Maybe";

import { CallAudioFragment } from "@/graphql/generated/graphql";
import { Slice } from "../store.decl";

export type AudioSliceState = {
  audio: Maybe<CallAudioFragment>;
  setAudio: (audio: Maybe<CallAudioFragment>) => void;
};

export const createAudioSlice: Slice<AudioSliceState> = (set) => ({
  audio: null,
  setAudio: (audio) => {
    set(() => ({
      audio,
    }));
  },
});
